import { render, staticRenderFns } from "./PromotionEditPosPrice.vue?vue&type=template&id=9f8b5f12&scoped=true&"
import script from "./PromotionEditPosPrice.vue?vue&type=script&lang=js&"
export * from "./PromotionEditPosPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8b5f12",
  null
  
)

export default component.exports